export default function mapToFactory(map) {
    return function(key) {
        return map[key];
    };
}

//# sourceMappingURL=mapToFactory.js.map